import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SEO } from '../components/SEO';

export const ContactSuccess = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen pt-16 flex items-center justify-center" style={{fontFamily:'IBM Plex Sans,sans-serif'}}>
      <SEO title={`${t('contact.success_title')} | Durable Designs`} path="/contact/success" />
      <div className="max-w-md mx-auto text-center px-4 py-20">
        <div className="w-12 h-12 border border-green-500 flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-6 h-6 text-green-600" />
        </div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-4" style={{fontFamily:'Outfit,sans-serif'}} data-testid="success-heading">
          {t('contact.success_title')}
        </h1>
        <p className="text-sm text-gray-500 mb-8">
          {t('contact.success_msg')}
        </p>
        <Link
          to="/engineering"
          className="inline-flex items-center bg-green-700 hover:bg-green-800 text-white px-6 py-3 text-sm font-medium tracking-wide transition-colors"
          data-testid="back-home-link"
        >
          {t('contact.success_back')}
        </Link>
      </div>
    </div>
  );
};

export default ContactSuccess;
